import { Controller } from "@hotwired/stimulus"

const STORAGE_PREFIX = "depozen:academy_onboarding_dashboard_banner:dismissed:"

// Hides the dashboard "Parcours de démarrage" banner; preference is stored per user in localStorage.
export default class extends Controller {
  static values = { userId: Number }

  connect() {
    if (this.dismissed()) this.hide()
  }

  dismiss(event) {
    event.preventDefault()
    this.persistDismissed()
    this.hide()
  }

  dismissed() {
    try {
      return localStorage.getItem(this.storageKey()) === "1"
    } catch {
      return false
    }
  }

  persistDismissed() {
    try {
      localStorage.setItem(this.storageKey(), "1")
    } catch {
      // Private browsing or storage disabled — still hide for this page view.
    }
  }

  storageKey() {
    return `${STORAGE_PREFIX}${this.userIdValue}`
  }

  hide() {
    this.element.classList.add("d-none")
  }
}
